import BaseController from "confinus_ui/base_controller";
import { DecorSuiteTablesDataTableRowIdentifier } from "decor";

interface DataTableRowOutlet {
  id: string;
  disabled: boolean;
}

export default class ModifyOrderFormController extends BaseController {
  public static outlets = [DecorSuiteTablesDataTableRowIdentifier];

  // Generated outlet accessor name: camelCase of identifier with double-dash
  // stripped, suffixed with `Outlets`.
  declare private readonly decorSuiteTablesDataTableRowOutlets: DataTableRowOutlet[];

  private get rowControllers(): DataTableRowOutlet[] {
    return this.decorSuiteTablesDataTableRowOutlets;
  }

  public toggleDisableRow(evt: CustomEvent<{ rowId: string }>) {
    const { rowId } = evt.detail;
    const rowToToggle = this.rowControllers.find((rc) => rc.id === rowId);
    if (rowToToggle) {
      rowToToggle.disabled = !rowToToggle.disabled;
    }
  }
}
